module.exports = __webpack_public_path__ + "static/media/mystery-vehicle-small.1d9469d5.jpg";